import { useEffect, useState } from "react";

// Client-side paging: filters/search run on the full list, only rendering is paged.
export const usePagedList = (items, defaultSize = 50) => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(defaultSize);
  const total = items.length;
  const totalPages = Math.max(1, Math.ceil(total / pageSize));

  useEffect(() => {
    setPage(1);
  }, [total]);

  const current = Math.min(page, totalPages);
  const start = (current - 1) * pageSize;
  return {
    pageItems: items.slice(start, start + pageSize),
    page: current,
    pageSize,
    total,
    onPageChange: (p) => {
      setPage(p);
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    onPageSizeChange: (size) => {
      setPageSize(Number(size));
      setPage(1);
    },
  };
};

export default usePagedList;
